require('jquery-ui');
require('jqueryEditable');
require('libs/jquery-editable/modules/datepicker.editable');
require('js/adapters/jquery.editable.ckeditor');
require('libs/jquery-editable/modules/formatted.select.editable');
require('libs/jquery-editable/modules/combobox.editable');
require('jqueryDatetimepicker');
require('jquery-datetimepicker/jquery.datetimepicker.css');
require('jquerySelect2');